import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledActionsContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    boxShadow: '0px -1px 6.3px 0px #A6A6A640',
    padding: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    borderTop: '1px solid #e9e9e9',
    padding: theme.spacing(2),
  },
}));
